import { Box, Stack, Tooltip } from "@mui/material";
import { DataGridPro, type GridRenderCellParams } from "@mui/x-data-grid-pro";
import { type FC, useMemo } from "react";
import type { ISO8601 } from "../../../../../utils/iso8601";
import { AnalyticsDatetime } from "../../../utils/analytics-datetime";
import { ExportToolbar } from "../../generic/export-toolbar";
import type { InteractionsByPerson } from "./types";

export const NestedPersonTable: FC<{ row: InteractionsByPerson }> = ({ row }) => {
  const columns = useMemo(() => {
    return [
      {
        field: "url",
        headerName: "URL",
        flex: 2,
        renderCell: (params: GridRenderCellParams<{ url: string }, string>) => (
          <Tooltip title={params.value}>
            <Box sx={{ whiteSpace: "normal", wordBreak: "break-all" }}>{params.value}</Box>
          </Tooltip>
        ),
      },
      {
        field: "clicks",
        headerName: "Clicks",
        flex: 0.5,
      },
      {
        field: "first_interaction",
        headerName: "First Interaction",
        flex: 2,
        renderCell: (params: GridRenderCellParams<{ first_interaction: ISO8601 }, ISO8601>) =>
          params.value ? (
            <Stack direction="row" spacing={1} alignItems="center" height="100%">
              <AnalyticsDatetime datetime={params.value} />
            </Stack>
          ) : null,
      },
      {
        field: "last_interaction",
        headerName: "Last Interaction",
        flex: 2,
        renderCell: (params: GridRenderCellParams<{ last_interaction: ISO8601 }, ISO8601>) =>
          params.value ? (
            <Stack direction="row" spacing={1} alignItems="center" height="100%">
              <AnalyticsDatetime datetime={params.value} />
            </Stack>
          ) : null,
      },
    ];
  }, []);

  return (
    <Box sx={{ ml: "50px" }}>
      <DataGridPro
        hideFooterRowCount
        slots={{ columnHeaders: () => null, toolbar: ExportToolbar }}
        rows={Object.entries(row.urls).map(
          ([url, { clicks, first_interaction, last_interaction }]) => ({
            id: url,
            url,
            clicks,
            first_interaction,
            last_interaction,
          }),
        )}
        columns={columns}
        disableRowSelectionOnClick
        showToolbar
      />
    </Box>
  );
};
